import React from "react";
import { Box, Link, Text } from "@chakra-ui/react";

export const Eyebrow = ({
  text,
  linkText,
  linkHref,
  mobileText,
}: {
  text: string;
  mobileText: string;
  linkText: string;
  linkHref: string;
}) => (
  <Box
    onClick={() => window.open(linkHref)}
    bgColor="indigo.300"
    color="white"
    width="100%"
    p="2"
    mb="2"
    position="fixed"
    top="0"
    textAlign={"center"}
    _hover={{
      cursor: "pointer",
    }}
  >
    {/* mobile eyebrow */}
    <Text display={{ base: "block", lg: "none" }} color="white" fontSize="md">
      {mobileText}
    </Text>

    {/* desktop eyebrow */}
    <Text display={{ base: "none", lg: "block" }} color="white" fontSize="md">
      {text}
      <Link fontWeight={"bold"} target="new" href={linkHref}>
        {linkText}
      </Link>
    </Text>
  </Box>
);
